import React from 'react';
import { getEmbedCode } from '../../utils';

const Embed = props => {
  return (
    <div className="ifdw-infobox-embed">
      <p className="ifdw-infobox--infotext">Mit diesem Code können Sie die Grafik “Wer zur Mittelschicht gehört“ kostenlos in Ihre Website einbetten. Wenn Sie die Werte "width" und "height" verändern, passt sich die Größe an.</p>
      <div className="ifdw-infobox--code">
        <code>{`${getEmbedCode()}`}</code>
      </div>
    </div>
  )
};

export default Embed;



/** WEBPACK FOOTER **
 ** ./src/components/Infobox/embed.js
 **/